import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';

export interface FPodcastRssSubmitBreadcrumbBarProps {
  activeLabel: string;
  className?: string;
  style?: React.CSSProperties;
  onReselect?(): void;
}

function FPodcastRssSubmitBreadcrumbBar({
  activeLabel,
  className = '',
  style,
  onReselect,
}: FPodcastRssSubmitBreadcrumbBarProps) {
  return (
    <div className={[styles.breadcrumbRow, className].join(' ')} style={style}>
      <div className={styles.breadcrumb}>
        <span className={styles.breadcrumbMuted}>单品添加方式</span>
        <span className={styles.breadcrumbSlash}>/</span>
        <span className={styles.breadcrumbActive}>{activeLabel}</span>
      </div>
      {onReselect && (
        <FComponentsLib.FTextBtn type='primary' style={{ fontSize: 14 }} onClick={onReselect}>
          重新选择添加方式
        </FComponentsLib.FTextBtn>
      )}
    </div>
  );
}

export default FPodcastRssSubmitBreadcrumbBar;
